import { isValidTenantDriver } from './validators/functions/is-valid-tenant-driver.function';

export * from './dtos/tenant-driver-search.dto';
export * from './dtos/tenant-driver.dto';

export * from './types/tenant-drivers-filters';

export * from './validators/schemas/create-tenant-driver.schema';
export * from './validators/schemas/update-tenant-driver.schema';

export const tenantDriverValidators = {
	isValidDriver: isValidTenantDriver,
};
